import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import {
  fetchBackupPlansStart,
  fetchGroupsStart,
  fetchDefaultPlanToCreatePlanStart
} from "store/actions";

import SearchBar from "./SearchBar";
import Notification from "./Notification";
import Notify from "App/common/ui/Notify";
import HeaderButtons from "./HeaderButtons";
import Table from "./Table";
import ServerDown from "App/common/ui/ServerDown";

function BackupPlan(props) {
  const [notification, setNotification] = useState({
    show: false,
    params: null
  });
  const [search, setSearch] = useState("");
  const [totalMachines, setTotalMachines] = useState(0);

  useEffect(() => {
    props.fetchDefaultPlanToCreatePlanStart();
    props.fetchBackupPlansStart();
    if (Object.keys(props.clientsObj.list).length <= 0)
      props.fetchGroupsStart();
  }, []);

  const showNotification = params =>
    setNotification({ show: true, params: params });

  const closeNotification = () => setNotification({ show: false });

  useEffect(() => {
    if (props.notification.backupPlan)
      showNotification(props.notification.backupPlan);
    else closeNotification();
  }, [props.notification]);

  const onChangeSearch = value => {
    if (value.length <= 50) {
      if (value.trim() !== "") {
        setSearch(value);
      } else setSearch("");
    } else setSearch(search);
  };

  const getTotalMachines = val => setTotalMachines(val);
  return (
    <div className="main_container_body">
      <div className="main_container_body__inner">
        <div className="bkpPlan_wrapper">
          {notification.show && (
            <Notify
              notify={notification}
              refresh={false}
              closeNotify={closeNotification}
            />
          )}
          <div className="fixed_container">
            <SearchBar
              search={search}
              onChangeSearch={onChangeSearch}
              totalMachines={totalMachines}
            />

            {/* <Notification /> */}

            <HeaderButtons />
          </div>
          {/* {totalMachines === 0 &&
            !props.backupPlan.backupPlans.loading &&
            search !== "" && <Empty />} */}
          {props.backupPlan.backupPlans.failed &&
          !props.backupPlan.backupPlans.loading ? (
            <ServerDown data={props.backupPlan.backupPlans.failed} />
          ) : (
            <Table
              search={search}
              getTotalMachines={getTotalMachines}
              totalMachines={totalMachines}
            />
          )}
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    clientsObj: state.dashboard.clients,
    backupPlan: state.backupPlan,
    notification: state.common.notification
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchBackupPlansStart,
      fetchGroupsStart,
      fetchDefaultPlanToCreatePlanStart
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(BackupPlan);
